module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Update Active Year\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('v-combobox', {
    attrs: {
      "items": _vm.years,
      "hide-selected": "",
      "chips": "",
      "label": "Active Year",
      "multiple": "",
      "error-messages": _vm.$v.updateData.activeYear.$error && "Active Year is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.updateData.activeYear.$touch()
      },
      "blur": function($event) {
        return _vm.$v.updateData.activeYear.$touch()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                $delete\n              ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.updateData.activeYear),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "activeYear", $$v)
      },
      expression: "updateData.activeYear"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.updateData.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02b6cf5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/MasterLists/ActiveYearModal.vue
// module id = 1971
// module chunks = 0